/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface ObterDetalheAnimalRequest {
  idAnimal: string;
}

interface Value {
  name: string;
  value: number;
}

interface Foto {
  id: string;
  caminho: string;
  fileUrl: string;
  nome: string;
  size: number;
  sizeFmt: string;
}

export interface ObterDetalheAnimalResponse {
  id: string;
  nome: string;
  raca: string;
  especie: Value;
  sexo: Value;
  porte: Value;
  idadeAnos: number | null;
  idadeMeses: number | null;
  pelagem: string;
  peso: number;
  corPredominante: string;
  doencasPreexistentes: Value[];
  castrado: boolean;
  desejaCastrar: boolean;
  desejaVacinar: boolean;
  vacinaEmDia: boolean;
  dataUltimaVacinacao: string | null;
  dataObito: string | null;
  arquivos: Foto[];
}

interface State {
  isRequesting: boolean;
  lastRequest: ObterDetalheAnimalRequest | null;
  successPayload: ObterDetalheAnimalResponse | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  lastRequest: null,
  successPayload: null,
  errors: []
};

const obterDetalheAnimalSlice = createSlice({
  name: "zoonose@obterDetalheAnimal",
  initialState,
  reducers: {
    obterDetalheAnimal: (
      state,
      action: PayloadAction<ObterDetalheAnimalRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
      state.lastRequest = {
        ...action.payload
      };
    },
    obterDetalheAnimalSuccess: (
      state,
      action: PayloadAction<ObterDetalheAnimalResponse>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterDetalheAnimalFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: ObterDetalheAnimalRequest;
}) {
  try {
    const { idAnimal } = params.payload;
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/saude/animal/${idAnimal}`
    );

    const { data } = response;

    yield put(obterDetalheAnimalSuccess(data));
  } catch (error) {
    yield put(obterDetalheAnimalFailed(formatError(error)));
  }
}

export const {
  obterDetalheAnimal,
  obterDetalheAnimalSuccess,
  obterDetalheAnimalFailed
} = obterDetalheAnimalSlice.actions;

export const { reducer } = obterDetalheAnimalSlice;

export const saga = takeLatest(obterDetalheAnimal.type, sagaFunction);
